/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Typography, CircularProgress } from '@material-ui/core';
import _ from 'lodash';
import approvalConstraints from '../../constants/approvalConstraints';
import BudgetVoteForm from './BudgetVoteForm';
import { actions as budgetActions } from '../../actions/budgetActions';
import BudgetVoteFormWizard from './BudgetVoteFormWizard';

class BudgetVotePage extends React.Component {
  state = {
    approvalConstraintOption: null,
  }

  componentDidMount() {
    this.props.actions.loadVoteFormSettings();
  }

  createFormInitialState() {
    const voterIdentificationMethodId = this.props.votingSettings.voterIdentificationMethods.length === 1
        ? this.props.votingSettings.voterIdentificationMethods[0].id
        : null;

    const voter = {};
    if (voterIdentificationMethodId) {
      const identificationMethod = this.props.votingSettings.voterIdentificationMethods.find(i => i.id === voterIdentificationMethodId);

      if (identificationMethod.voterRequiredData.address) {
        if (!identificationMethod.terytEnabled
          && !identificationMethod.streetsAutocomplete
          && identificationMethod.voterRequiredData.addressRestrictedToCities
          && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
          voter.city = identificationMethod.voterRequiredData.addressRestrictedToCities[0];
        } else if (!identificationMethod.terytEnabled
          && identificationMethod.streetsAutocomplete
          && identificationMethod.voterRequiredData.addressRestrictedToCities
          && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
          const data = _.uniqBy(identificationMethod.streetsAutocompleteData, s => s.cityId);
          const city = data.find(c => c.cityName === identificationMethod.voterRequiredData.addressRestrictedToCities[0]);
          if (city) {
            voter.city = city.cityName;
            voter.cityId = city.cityId;
          }
        }
      }
    }

    return {
      budgetId: this.props.votingSettings.id,
      voterIdentificationMethodId,
      voter,
      votes: [],
    };
  }

  submitForm = data => {
    if (this.props.votingSettings.approvals
      && this.props.votingSettings.approvals.filter(a => a.appliesTo !== approvalConstraints.all.value).length
      && !this.state.approvalConstraintOption)
      return;

    if (data.voter && !data.voter.address && data.voter.teryt) {
      data.voter.teryt.streetCode = null;
    }
    
    return this.props.actions.vote(data);
  }

  confirmSubmitError = () => {
    if (this.props.voteError != null
      && (this.props.voteError === 'alreadyVoted' || this.props.voteError.startsWith('ageVerificationFailed'))) {
      window.location.href = 'https://' + window.location.host;
    }
    else {
      this.props.actions.confirmVoteError();
    }
  }

  renderErrorDialogContent = () => {
    const { voteError, votingSettings } = this.props;
    if (voteError === 'alreadyVoted')
      return <Typography variant="subtitle1">{votingSettings.customMessages.alreadyVoted || 'Wpisane dane zostały już wcześniej wykorzystane do głosowania w aktualnym Budżecie. W celu wyjaśnień wątpliwości prosimy o kontakt z Urzędem - dane kontaktowe dostępne są w zakładce "Kontakt" na stronie głównej portalu.'}</Typography>;
    if (voteError === 'notVerified')
      return <Typography variant="subtitle1">{votingSettings.customMessages.notVerified || 'Mieszkańcu nie zostałeś zidentyfikowany. Twój głos będzie ważny po potwierdzeniu tożsamości w Urzędzie. Być może zrobiłeś "literówkę", spróbuj ponownie. Jeżeli to nie przyniesie efektu prosimy o kontakt z Urzędem - dane kontaktowe dostępne są w zakładce "Kontakt" na stronie głównej portalu.'}</Typography>;
    if (voteError === 'phoneVerificationError')
      return <Typography variant="subtitle1">Podano nieprawidłowy kod weryfikacyjny SMS</Typography>;
    if (voteError != null && voteError.startsWith('ageVerificationFailed'))
      return <Typography variant="subtitle1">{votingSettings.customMessages.ageVerificationFailed || 'Mieszkańcu Twój głos został odrzucony ze względu na ograniczenie wieku osób uprawnionych do głosowania. Zapoznaj się z regulaminem głosowania lub skontaktuj się z Urzędem.'}</Typography>;
    return <Typography variant="subtitle1">Wystąpił problem podczas oddawania głosu. Upewnij się, że wybrałeś co najmniej jeden projekt.</Typography>;
  }

  render() {
    const { fetching, votingSettings, unit, cms } = this.props;

    return (<React.Fragment>
      <div key="top" className="row top">
        <div className="col-sm-2" />
        <div className="col-sm-3" />
        <div className="col-sm-7 header">
          <a href="/budzet-obywatelski" className="btn"><i className="fa fa-long-arrow-alt-left" /> powrót</a>
        </div>
      </div>
      {fetching ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
        <div key="content" style={{ marginTop: 40 }}>
          <div className="row">
            <div className="box">
              <div className="col-sm-12 text-center">
                <h2 className="box-header">{votingSettings.name} <span>Formularz głosowania</span></h2>
              </div>
              <div className="col-sm-12">
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  spacing={2}
                >
                  {cms.budget.disabled ? null : <Grid item>
                    <a href="/budzet-obywatelski/o-budzecie" target="_blank" rel="noopener noreferrer" className="btn">Zasady głosowania</a>
                  </Grid>}
                  <Grid item>
                    <a href="/budzet-obywatelski#lista-projektow" target="_blank" rel="noopener noreferrer" className="btn">Szczegóły projektów</a>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>

          {(votingSettings.votingGuidelines && votingSettings.votingGuidelines != '<p></p>\n') ? <div className="row">
            <div className="box">
              <div className="col-sm-12">
                <div dangerouslySetInnerHTML={{ __html: votingSettings.votingGuidelines }} />
              </div>
            </div>
          </div> : null}

          {votingSettings.districtStreetsFilters && votingSettings.districtStreetsFilters.length
            ? <BudgetVoteFormWizard
                votingSettings={votingSettings}
                unit={unit}
                onSubmit={this.submitForm}
                initialValues={this.createFormInitialState()}
                disabled={this.props.preview}
                approvalConstraintOption={this.state.approvalConstraintOption}
                onApprovalConstraintPick={type => this.setState({ approvalConstraintOption: type })}
                actions={this.props.actions}
              />
            : <BudgetVoteForm
                votingSettings={votingSettings}
                unit={unit}
                onSubmit={this.submitForm}
                initialValues={this.createFormInitialState()}
                disabled={this.props.preview}
                approvalConstraintOption={this.state.approvalConstraintOption}
                onApprovalConstraintPick={type => this.setState({ approvalConstraintOption: type })}
                actions={this.props.actions}
              />}
          <Dialog open={this.props.success && !this.props.voteError} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">{votingSettings.customMessages.successTitle || 'Wszystko OK - dziękujemy za oddany głos!'}</DialogTitle>
            <DialogContent>
              <Typography variant="subtitle1">{votingSettings.customMessages.successContent || 'Prosimy o śledzenie kolejnych etapów Budżetu zgodnie z harmonogramem i zapoznanie z wynikami po zakończeniu głosowania.'}</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { window.location.href = 'https://' + window.location.host; }} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.props.voteError == null ? false : true} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Uwaga</DialogTitle>
            <DialogContent>
              {this.renderErrorDialogContent()}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.confirmSubmitError} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>
        </div>}
    </React.Fragment>);
  }
}

BudgetVotePage.defaultProps = {
  success: false,
};

BudgetVotePage.propTypes = {
  budgetVoteForm: PropTypes.object,
  actions: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  votingSettings: PropTypes.object,
  preview: PropTypes.bool,
  cms: PropTypes.object.isRequired,
  success: PropTypes.bool,
  voteError: PropTypes.string,
  unit: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    success: state.budgetVoting.success,
    voteError: state.budgetVoting.voteError,
    fetching: state.budgetVoting.fetching,
    votingSettings: state.budgetVoting.data,
    preview: window.location.href.includes('podglad'),
    cms: state.cms,
    unit: state.unit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(budgetActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetVotePage);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetVotePage.js